var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.75 99H21.6875C17.9375 99 15 95.705 15 91.5C15 87.295 17.9375 84 21.6875 84H30.47V90H21.6875C21.51 90 21 90.515 21 91.5C21 92.485 21.5125 93 21.6875 93H45.75V99Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60 57C53.3825 57 48 51.3 48 44.2925V38.1525C48 30.245 53.11 27.425 58.345 25.2125L67.84 21.2325C68.7675 20.845 69.825 20.945 70.66 21.5025C71.495 22.0575 71.9975 22.995 71.9975 24V44.2925C71.9975 51.3 66.615 57 59.9975 57H60ZM66 28.51L60.6725 30.7425C55.6675 32.855 54 34.2225 54 38.15V44.29C54 47.9875 56.6925 50.9975 60 50.9975C63.3075 50.9975 66 47.9875 66 44.29V28.5075V28.51Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63 99H43.0675C41.41 99 40.0675 97.6575 40.0675 96V95.97H43.0675V93H60C60 91.345 58.655 90 57 90H54C52.3425 90 51 88.6575 51 87V78H57V84C61.9625 84 66 88.0375 66 93V96C66 97.6575 64.6575 99 63 99Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M87 48H79.5C78.9075 48 78.3275 47.825 77.835 47.495L73.335 44.495L76.6625 39.5025L80.405 41.9975H86.9975C88.6525 41.9975 89.9975 40.6525 89.9975 38.9975V35.9975H83.9975C82.825 35.9975 81.76 35.315 81.27 34.2475C79.92 31.325 76.8075 26.9975 74.425 26.9975H68.46V20.9975H74.425C77.67 20.9975 80.77 22.91 83.64 26.68C84.55 27.875 85.2875 29.0675 85.8125 29.9975H92.9975C94.655 29.9975 95.9975 31.34 95.9975 32.9975V38.9975C95.9975 43.96 91.96 47.9975 86.9975 47.9975L87 48Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66 99V78H72V93H87C87 91.345 85.655 90 84 90H75V78H78C82.9625 78 87 73.9625 87 69C87 64.0375 82.9625 60 78 60H74.965L75.07 50.965L81.07 51.035L81.0325 54.3075C87.855 55.7125 93.0025 61.7675 93.0025 69C93.0025 76.2325 87.84 82.305 81.0025 83.6975V84H84.0025C88.965 84 93.0025 88.0375 93.0025 93V99H66Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42 99C32.075 99 24 90.2525 24 79.5C24 70.54 29.595 62.7625 37.605 60.585C41.26 59.5925 45.03 58.13 48.805 56.2425L58.6575 51.315L61.34 56.6825L51.4875 61.61C47.3575 63.675 43.215 65.28 39.1775 66.375C33.775 67.8425 30 73.24 30 79.5C30 86.945 35.3825 93 42 93V99Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDog);
export default __webpack_public_path__ + "static/media/Dog.480dfa86.svg";
export { ForwardRef as ReactComponent };